import { types, actions } from './requests'
export const CREATEBADGE_TYPES = {
    ...types('CREATEBADGE'),
}
export const CREATEBADGE_ACTIONS = {
    ...actions('CREATEBADGE'),
}